(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-marquee"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function setupMarquee(inner) {
      const original = inner.querySelector('.announcement-marquee__set');
      if (!original) return;

      // Remove previous clones
      inner.querySelectorAll('.announcement-marquee__set:not(:first-child)').forEach(function (el) {
        el.remove();
      });

      var setWidth = original.offsetWidth;
      if (!setWidth) return;

      // Clone until content fills at least 2x the viewport (guarantees no gaps)
      var needed = Math.ceil((window.innerWidth * 2) / setWidth) + 1;
      for (var i = 1; i < needed; i++) {
        inner.appendChild(original.cloneNode(true));
      }

      inner.style.setProperty('--marquee-set-width', setWidth + 'px');
    }

    document.querySelectorAll('.announcement-marquee__inner').forEach(function (inner) {
      setupMarquee(inner);
      window.addEventListener('resize', function () { setupMarquee(inner); });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
